import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap } from 'rxjs';

/**
 * /group/* valida JWT (id_token). El interceptor OIDC manda el access token opaco,
 * que el backend responde como 401 invalid_token.
 */
export const groupAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const isGroupRequest = /\/group(\/|\?|$)/.test(req.url);
  if (!isGroupRequest) {
    return next(req);
  }

  const oidc = inject(OidcSecurityService);
  return oidc.getIdToken().pipe(
    switchMap((idToken) => {
      if (!idToken) return next(req);
      return next(
        req.clone({
          setHeaders: { Authorization: `Bearer ${idToken}` },
        }),
      );
    }),
  );
};
